import React from "react";
import PropTypes from "prop-types";
import { SectionTitleType, ButtonType, ItemType } from "@streamo/helper/types";
import { SwiperSlider, SwiperSlide } from "gatsby-theme-ui";
import { SectionTitleTwo, StreamItemCardTwo } from "gatsby-theme-component";

const VideoStreamingContainer = ({ data }) => (
    <section className="coming-soon-seciton bg-black section-space-pt-50">
        <div className="container-full px-4 md:px-24">
            {data?.section_title && (
                <SectionTitleTwo className="mb-3" {...data?.section_title} />
            )}
            <SwiperSlider
                className="streaming-two-slider"
                options={{
                    autoplay: false,
                    slidesPerView: 1,
                    navigation: true,
                    pagination: false,
                    spaceBetween: 30,
                    loop: false,
                    centeredSlides: false,
                    breakpoints: {
                        420: {
                            slidesPerView: 2,
                        },
                        672: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 4,
                        },
                        1200: {
                            slidesPerView: 5,
                        },
                        1600: {
                            slidesPerView: 6,
                        },
                    },
                }}
                navPosition={2}
            >
                {data?.items?.map((item) => (
                    <SwiperSlide key={item.id}>
                        <StreamItemCardTwo
                            title={item?.title}
                            image={item?.image}
                            slug={item?.slug}
                            quality={item?.quality}
                            rating={item?.rating}
                            comingSoon={item?.comingSoon}
                        />
                    </SwiperSlide>
                ))}
            </SwiperSlider>
        </div>
    </section>
);

VideoStreamingContainer.propTypes = {
    data: PropTypes.shape({
        section_title: PropTypes.shape(SectionTitleType),
        buttons: PropTypes.arrayOf(PropTypes.shape(ButtonType)),
        items: PropTypes.arrayOf(PropTypes.shape(ItemType)),
    }),
};

export default VideoStreamingContainer;
